import MKEvent from '../utils/MKEvent';
import LinesController from './LinesController';

export default class SlotControls {
	constructor(scene, slotPlayer, linesData, lineColor, lineBetMaxValue) {
		this.slotPlayer = slotPlayer;
		this.scene = scene;
		this.linesController = new LinesController(this.scene, this, linesData, lineColor, this.scene.reels, this.scene.lineButtons);
		this.lines = this.linesController.lines;

		// default settings
		this.manualStop = false;
		this.holdToAutoSpin = false; // hold spin button pressed 2 sec to start auto spin mode
		this.maxLineBet = lineBetMaxValue;
		this.defaultLineBet = 1;
		this.autoPlayFreeSpins = true;

		// slot input parameters
		this.lineBet = 1;
		this.holdMultiplier = 1;
		this.selectedLinesCount = 0;
		this.freeSpins = 0;
		this.auto = false;
		this.autoSpinsCounter = 0;

		// slot input controls
		this.hold = null;
		this.buttons = []; // all control buttons array

		// slot output controls
		this.freeSpinText = null; // freeSpinText;
		this.spinText = null; // spinText;
		this.autoSpinsCountText = null; // autoSpinsCountText;

		// events
		this.changeTotalBetEvent = new MKEvent();
		this.changeLineBetEvent = new MKEvent();
		this.changeSelectedLinesEvent = new MKEvent();
		this.changeFreeSpinsEvent = new MKEvent();
		this.changeAutoSpinsCounterEvent = new MKEvent();
		this.changeAutoSpinModeEvent = new MKEvent();
		this.tryToSetAutoSpinModeEvent = new MKEvent();

		// set event handlers
		this.changeFreeSpinsEvent.add(this.changeFreeSpinsHandler, this);
		this.changeTotalBetEvent.add(this.changeTotalBetHandler, this);
		this.changeLineBetEvent.add(this.changeLineBetHandler, this);
		this.changeSelectedLinesEvent.add(this.changeSelectedLinesHandler, this);
		this.slotPlayer.addWinCoinsChangeEvent(this.changeWinCoinsHandler, this);
		this.slotPlayer.addChangeCoinsEvent(this.changeCreditCoinsHandler, this);
	}

	init(selectLines, burn) {
		if (this.hold !== null)
			this.hold.changeBetMultiplierEvent.add(hm => {
				this.refreshBetLines();
			}, this);
		this.changeAutoSpinsCounterEvent.add((r, i) => {
			if (this.autoSpinsCountText != null) this.autoSpinsCountText.text = i;
		}, this);
		this.changeSelectedLinesEvent.add((l, b) => {
			if (this.infoText !== null) this.infoText.text = l > 0 ? 'Click to SPIN to start!' : 'Select any slot line!';
		}, this);
		if (selectLines === 'all') {
			this.setSelectedLinesCount(this.lines.length, burn);
		} else {
			this.setSelectedLinesCount(1, burn);
		}
		this.refresh();
	}

	isAnyLineSelected() {
		return this.selectedLinesCount > 0;
	}

	hasFreeSpin() {
		return this.freeSpins > 0;
	}

	useHold() {
		return this.hold !== null && this.hold.enabled;
	}

	isReelsSpin() {
		return this.slot !== null && this.slot.ReelsSpin;
	}

	useManualStop() {
		return this.manualStop && !this.auto;
	}

	setControlActivity(activity, spinButtonActivity, autoSpinButtonActivity) {
		console.log(
			'setControlActivity(activity, spinButtonActivity, autoSpinButtonActivity): ' +
				activity +
				',' +
				spinButtonActivity +
				',' +
				autoSpinButtonActivity
		);
		if (this.menuController) this.menuController.setControlActivity(activity);
		if (this.linesController) {
			this.linesController.setControlActivity(activity);
		}

		if (this.buttons != null) {
			this.buttons.forEach(b => {
				if (b) b.interactable = activity;
			});
		}

		if (this.slotSpinButton != null) this.slotSpinButton.setInteractable(spinButtonActivity);
		if (this.slotAutoSpinButton != null) this.slotAutoSpinButton.setInteractable(autoSpinButtonActivity);
	}

	refresh() {
		this.refreshBetLines();
		this.refreshSpins();
		if (this.winAmountText != null) this.winAmountText.text = 0;
	}

	refreshBetLines() {
		if (this.lineBetAmountText != null) this.lineBetAmountText.text = this.lineBet;
		if (this.lineBetAmountText != null) this.totalBetSumText.text = this.getTotalBet();
		if (this.linesCountText != null) this.linesCountText.text = this.selectedLinesCount;
	}

	refreshSpins() {
		if (this.autoSpinsCountText != null) this.autoSpinsCountText.text = this.autoSpinCount;
		if (this.freeSpinText != null) this.freeSpinText.text = this.freeSpins > 0 ? 'Free' : '';
		if (this.freeSpinCountText != null) this.freeSpinCountText.text = this.freeSpins > 0 ? this.freeSpins : '';
	}

	linesLoop_Click() {
		// loop lines
		if (this.linesController.lines.length <= this.selectedLinesCount) {
			this.setSelectedLinesCount(1, true);
		} else {
			this.addSelectedLinesCount(1, true);
		}
		this.scene.soundController.playClip('button_click');
	}

	linesPlus_Click() {
		this.addSelectedLinesCount(1, true);
		this.scene.soundController.playClip('button_click');
	}

	linesMinus_Click() {
		this.addSelectedLinesCount(-1, false);
		this.scene.soundController.playClip('button_click');
	}

	lineBetPlus_Click() {
		this.addLineBet(1);
		this.scene.soundController.playClip('button_click');
	}

	lineBetLoop_Click() {
		if (this.lineBet < this.maxLineBet) {
			this.addLineBet(1);
		} else {
			this.setLineBet(1);
		}
		this.scene.soundController.playClip('button_click');
	}

	lineBetMinus_Click() {
		this.addLineBet(-1);
		this.scene.soundController.playClip('button_click');
	}

	autoSpinPlus_Click() {
		this.addAutoSpins(1);
		this.scene.soundController.playClip('button_click');
	}

	autoSpinMinus_Click() {
		this.addAutoSpins(-1);
		this.scene.soundController.playClip('button_click');
	}

	maxBet_Click() {
		this.linesController.selectAllLines(true);
		this.setMaxLineBet();
		this.scene.soundController.playClip('button_click');
	}

	changeFreeSpinsHandler(newFreeSpinsCount) {
		if (this.freeSpinText != null) this.freeSpinText.text = this.freeSpins > 0 ? 'Free' : '';
		if (this.freeSpinCountText != null) this.freeSpinCountText.text = newFreeSpinsCount > 0 ? newFreeSpinsCount : '';
	}

	changeTotalBetHandler(newTotalBet) {
		if (this.totalBetSumText != null) this.totalBetSumText.text = newTotalBet;
	}

	changeLineBetHandler(newLineBet) {
		if (this.lineBetAmountText != null) this.lineBetAmountText.text = newLineBet;
	}

	changeSelectedLinesHandler(newCount, burn) {
		newCount = Math.min(newCount, this.lines.length);
		for (var i = 0; i < this.lines.length; i++) {
			if (i < newCount) {
				if (!this.lines[i].isSelected) {
					this.lines[i].select(burn);
				}
			} else {
				if (this.lines[i].isSelected) {
					this.lines[i].deselect();
				}
			}
		}
		if (this.linesCountText != null) this.linesCountText.text = newCount;
	}

	changeWinCoinsHandler(newCount) {
		if (this.winAmountText != null) this.winAmountText.text = newCount;
	}

	changeCreditCoinsHandler(newCount) {
		if (this.creditSumText != null) this.creditSumText.text = '$' + newCount;
	}

	addLineBet(count) {
		this.setLineBet(this.lineBet + count);
	}

	setLineBet(count) {
		console.log('current line bet: ' + this.lineBet);
		count = Math.max(1, count);
		count = Math.min(count, this.maxLineBet);
		var changed = this.lineBet != count;
		this.lineBet = count;
		console.log('set new line bet: ' + this.lineBet);
		if (changed) {
			this.changeLineBetEvent.events.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.lineBet);
			});
			this.changeTotalBetEvent.events.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.getTotalBet());
			});
		}
	}

	setMaxLineBet() {
		this.setLineBet(this.maxLineBet);
	}

	applyBet() {
		if (this.slotPlayer.hasMoneyForBet(this.getTotalBet())) {
			this.slotPlayer.addCoins(-this.getTotalBet());
			return true;
		} else {
			return false;
		}
	}

	addSelectedLinesCount(count, burn) {
		this.setSelectedLinesCount(this.selectedLinesCount + count, burn);
	}

	setSelectedLinesCount(count, burn) {
		count = Math.max(1, count);
		count = Math.min(this.linesController.lines.length, count);
		var changed = this.selectedLinesCount != count;
		this.selectedLinesCount = count;
		if (changed) {
			this.changeSelectedLinesEvent.events.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, count, burn);
			});
			this.changeTotalBetEvent.events.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.getTotalBet());
			});
		}
		console.log('selectedLinesCount: ' + this.selectedLinesCount);
	}

	addFreeSpins(count) {
		this.setFreeSpinsCount(this.freeSpins + count);
	}

	setFreeSpinsCount(count) {
		count = Math.max(0, count);
		var changed = this.freeSpins != count;
		this.freeSpins = count;
		if (changed)
			this.changeFreeSpinsEvent.events.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.freeSpins);
			});
	}

	loadFreeSpins() {
		this.setFreeSpinsCount(0);
	}

	applyFreeSpin() {
		if (this.hasFreeSpin) {
			this.addFreeSpins(-1);
			return true;
		} else {
			return false;
		}
	}

	incAutoSpinsCounter() {
		this.setAutoSpinsCounter(this.autoSpinsCounter + 1);
	}

	setAutoSpinsCounter(count) {
		count = Math.max(0, count);
		var changed = count != this.autoSpinsCounter;
		this.autoSpinsCounter = count;
		if (changed)
			this.changeAutoSpinsCounterEvent.events.forEach(eW => {
				if (eW != null && eW.action != null) eW.action.call(eW.context, this.autoSpinsCounter, this.autoSpinCount);
			});
	}

	resetAutoSpinsMode() {
		this.auto = false;
		this.changeAutoSpinModeEvent.events.forEach(eW => {
			if (eW != null && eW.action != null) eW.action.call(eW.context, false);
		});
	}

	setAutoSpinsMode() {
		this.setAutoSpinsCounter(0);
		this.auto = true;
		this.changeAutoSpinModeEvent.events.forEach(eW => {
			if (eW != null && eW.action != null) eW.action.call(eW.context, true);
		});
	}

	setDefaultData() {
		this.setLineBet(this.defaultLineBet);
	}

	setSpinButtonText(text) {
		if (this.spinText != null) this.spinText.text = text;
	}

	getTotalBet() {
		return this.selectedLinesCount * this.lineBet * this.holdMultiplier;
	}
}
